export const colors = {
  primary: '#ff955f',
  primaryDim: '#ef8853',
  onPrimary: '#562000',
  primaryContainer: '#ec8651',

  secondary: '#fb9038',
  secondaryDim: '#ea832c',
  tertiary: '#ffc96d',
  tertiaryContainer: '#feb726',

  error: '#ff7351',
  onError: '#450900',

  success: '#32a54a',
  onSuccess: '#ffffff',

  surface: '#151515',
  surfaceDim: '#151515',
  surfaceBright: '#2a2a2a',
  surfaceContainerLowest: '#0a0a0a',
  surfaceContainerLow: '#1a1a1a',
  surfaceContainer: '#242424',
  surfaceContainerHigh: '#2d2d2d',
  surfaceContainerHighest: '#333333',

  onSurface: '#ffe7d6',
  onSurfaceVariant: '#c79a76',

  outline: '#9d6a45',
  outlineVariant: '#683e1d',

  sidebar: '#1b0900',
};

export const typography = {
  fontFamily: "'Lexend', sans-serif",
  display: {
    fontSize: '64px',
    fontWeight: 800,
    lineHeight: '72px',
  },
  headlineLg: {
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: '40px',
  },
  headlineMd: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '32px',
  },
  bodyLg: {
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '28px',
  },
  bodyMd: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  label: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.05em',
    textTransform: 'uppercase' as const,
  },
};

export const radius = {
  sm: '0.25rem',
  DEFAULT: '0.5rem',
  md: '0.75rem',
  lg: '1rem',
  full: '9999px',
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '48px',
};
